var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.81 12.75C22.81 11.97 22.74 11.22 22.61 10.5H12.25V14.76H18.17C17.91 16.13 17.13 17.29 15.96 18.07V20.84H19.53C21.61 18.92 22.81 16.1 22.81 12.75Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2501 23.5C15.2201 23.5 17.7101 22.52 19.5301 20.84L15.9601 18.07C14.9801 18.73 13.7301 19.13 12.2501 19.13C9.39005 19.13 6.96005 17.2 6.09005 14.6H2.43005V17.44C4.24005 21.03 7.95005 23.5 12.2501 23.5Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09 14.59C5.87 13.93 5.74 13.23 5.74 12.5C5.74 11.77 5.87 11.07 6.09 10.41V7.57001H2.43C1.68 9.05001 1.25 10.72 1.25 12.5C1.25 14.28 1.68 15.95 2.43 17.43L5.28 15.21L6.09 14.59Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2501 5.88C13.8701 5.88 15.3101 6.44 16.4601 7.52L19.6101 4.37C17.7001 2.59 15.2201 1.5 12.2501 1.5C7.95005 1.5 4.24005 3.97 2.43005 7.57L6.09005 10.41C6.96005 7.81 9.39005 5.88 12.2501 5.88Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleColor);
export default __webpack_public_path__ + "static/media/googleColor.47dd78ec664e2ed403e5e4ddce99a2f7.svg";
export { ForwardRef as ReactComponent };